/* eslint-disable react/prop-types */
import { UpsellBaseModal } from '../UpsellBaseModal'
import { OfferBox } from '../OfferBox'

export const SinglePurchaseModal = ({
  isOpen,
  onClose,
  title = 'Quer finalizar apenas esta campanha?',
  subtitle = 'Desbloqueie só o download dela — sem artes extras.',
  offer,
  primaryAction,
  dismissAction,
  showCloseButton = true,
}) => {
  return (
    <UpsellBaseModal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      subtitle={subtitle}
      titleId="single-purchase-modal-title"
      showCloseButton={showCloseButton}
      primaryAction={primaryAction}
      secondaryAction={dismissAction}
    >
      {offer && (
        <OfferBox
          variant="solid"
          label={offer.label}
          price={offer.price}
          description={offer.description}
          subdescription={offer.subdescription}
        />
      )}
    </UpsellBaseModal>
  )
}

export default SinglePurchaseModal
